import createRemoteArrayResourceReducer from "./helpers/createRemoteArrayResourceReducer";

export default createRemoteArrayResourceReducer("CONTRACT_RENEWALS");
